import React from 'react';
import '../gestvendas.css';
import { AreaChart,LineChart, Line ,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
const data = [{name: 'Page A', uv: 200, pv: 2400, amt: 2400},{name: 'Page B', uv: 100, pv: 2400, amt: 2400}];


function GestVendas() {
  const data=[];
  for(let num=30;num>=0;num--){
      data.push({
          date:subDays(new Date(),num).toISOString().substr(0,10),
          value:1+Math.random(),
          mpesa:1-Math.random(),
          emola:0.5*Math.random(),
      })
  }
  return <ResponsiveContainer width="100%" height={400}  className="casa">
      <AreaChart data={data} >
        <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#053f40' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#053f40' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ffa500' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ffa500' stopOpacity={0.05}></stop>
            </linearGradient>
        </defs>
        <Area dataKey="value" stroke="#053f40" fill="url(#color)"/>
        <Area dataKey="mpesa" stroke="#ca2210" fill="url(#colors)"/>
        <Area dataKey="emola" stroke="#ffa500" fill="url(#colorsa)"/>
        
        <XAxis dataKey="date"
        axisLine={false}
        tickLine={false}
        tickFormatter={str=>{
            const date=parseISO(str);
            if(date.getDate() %7==0){
                return  format(date,"MMM, d")
            }
            return ""
        }}/>
        <YAxis dataKey="value"
        axisLine={false}
        tickLine={false}
        tickCount={8}
        tickFormatter={number=>`$${number.toFixed(2)}`}/>
        <Tooltip/>
        <CartesianGrid opacity={0.1} vertical={false}/>
      </AreaChart>
  </ResponsiveContainer>;
}

export default GestVendas;
